import React from "react";
import classNames from "classnames";
import { LiveDot } from "@design-system/LiveDot/LiveDot";
import { ArrowRightIcon } from "@icons";
import styles from "./NavNotice.module.scss";

interface NavNoticeProps {
    onClick: () => void;
    label: string;
    /** Read after `label` by screen readers only, e.g. what a click does. */
    hint: string;
}

/**
 * A persistent, clickable notice in the side nav footer: a compact one-line
 * label behind a pulsing dot. Generic on purpose so it can back other nav-level
 * announcements (e.g. new version, feature releases), not just the new-version
 * notice.
 */
export const NavNotice: React.FC<NavNoticeProps> = ({
    onClick,
    label,
    hint,
}) => (
    <button
        type="button"
        onClick={onClick}
        className={classNames(styles.notice, styles.inline)}
    >
        <span className={styles.lead}>
            <LiveDot variant="accent" className={styles.dot} />
            <span className={styles.label}>{label}</span>{" "}
            <span className={styles.hint}>{hint}</span>
        </span>
        <ArrowRightIcon className={styles.chevron} />
    </button>
);
